(function() {
  function initSupportHeader(section) {
    if (!section || section.dataset.supportHeaderReady === 'true') {
      return;
    }

    var headerWrapper = section.closest('#ntheader');
    var overlay = section.querySelector('[data-support-overlay]');
    var toggleButtons = section.querySelectorAll('[data-support-open]');
    var closeButtons = section.querySelectorAll('[data-support-close]');
    var panels = section.querySelectorAll('[data-support-panel]');
    var closeOnActivateLinks = section.querySelectorAll('[data-support-close-on-activate]');
    var searchInput = section.querySelector('[data-support-search-input]');
    var activePanelName = null;
    var headerResizeMq = window.matchMedia('(max-width: 1023px)');
    var wrapperObserver = null;
    var isSyncingWrapperHeight = false;

    section.dataset.supportHeaderReady = 'true';

    function getActiveHeaderHeight() {
      var bar = section.querySelector('.support-site-header__bar');

      if (bar) {
        var measuredHeight = Math.ceil(bar.getBoundingClientRect().height);

        if (measuredHeight > 0) {
          return measuredHeight;
        }
      }

      var styles = window.getComputedStyle(section);
      var heightValue = headerResizeMq.matches
        ? styles.getPropertyValue('--support-header-height-mobile')
        : styles.getPropertyValue('--support-header-height-desktop');
      var parsedHeight = parseFloat(heightValue);

      if (isNaN(parsedHeight) || parsedHeight <= 0) {
        parsedHeight = 0;
      }

      return parsedHeight > 0 ? parsedHeight : 0;
    }

    function syncWrapperHeight() {
      var activeHeight = getActiveHeaderHeight();

      if (!activeHeight) {
        return;
      }

      var heightValue = Math.round(activeHeight) + 'px';

      section.style.setProperty('--support-header-current-height', heightValue);
      document.documentElement.style.setProperty('--support-header-current-height', heightValue);

      if (!headerWrapper) {
        return;
      }

      isSyncingWrapperHeight = true;
      headerWrapper.style.setProperty('--support-header-current-height', heightValue);
      headerWrapper.style.height = heightValue;
      headerWrapper.style.minHeight = heightValue;

      window.requestAnimationFrame(function() {
        isSyncingWrapperHeight = false;
      });
    }

    function queueWrapperHeightSync() {
      window.requestAnimationFrame(syncWrapperHeight);
      window.setTimeout(syncWrapperHeight, 0);
    }

    function updateStickyState() {
      var isPinned = window.scrollY > 0;

      section.classList.toggle('is-sticky', isPinned);
      section.classList.toggle('is-pinned', isPinned);
    }

    function updateButtons() {
      toggleButtons.forEach(function(button) {
        var panelName = button.getAttribute('data-support-open');
        var isActive = panelName === activePanelName;

        button.setAttribute('aria-expanded', isActive ? 'true' : 'false');

        if (panelName === 'menu') {
          button.classList.toggle('is-active', isActive);
        }
      });
    }

    function closePanels() {
      panels.forEach(function(panel) {
        panel.classList.remove('is-active');
        panel.setAttribute('aria-hidden', 'true');
      });

      activePanelName = null;
      document.body.classList.remove('support-header-ui-lock');

      if (overlay) {
        overlay.classList.remove('is-active');
        overlay.hidden = true;
      }

      updateButtons();
    }

    function openPanel(panelName) {
      var nextPanel = section.querySelector('[data-support-panel="' + panelName + '"]');

      if (!nextPanel) {
        return;
      }

      panels.forEach(function(panel) {
        var isTarget = panel === nextPanel;
        panel.classList.toggle('is-active', isTarget);
        panel.setAttribute('aria-hidden', isTarget ? 'false' : 'true');
      });

      activePanelName = panelName;
      document.body.classList.add('support-header-ui-lock');

      if (overlay) {
        overlay.hidden = false;
        overlay.classList.add('is-active');
      }

      updateButtons();

      window.setTimeout(function() {
        if (panelName === 'search' && searchInput) {
          searchInput.focus();
          return;
        }

        if (typeof nextPanel.focus === 'function') {
          nextPanel.focus();
        }
      }, 80);
    }

    toggleButtons.forEach(function(button) {
      button.addEventListener('click', function() {
        var panelName = button.getAttribute('data-support-open');

        if (!panelName) {
          return;
        }

        if (activePanelName === panelName) {
          closePanels();
          return;
        }

        openPanel(panelName);
      });
    });

    closeButtons.forEach(function(button) {
      button.addEventListener('click', closePanels);
    });

    closeOnActivateLinks.forEach(function(link) {
      link.addEventListener('click', closePanels);
    });

    if (overlay) {
      overlay.addEventListener('click', closePanels);
    }

    document.addEventListener('keydown', function(event) {
      if (event.key === 'Escape' && activePanelName) {
        closePanels();
      }
    });

    window.addEventListener(
      'scroll',
      function() {
        updateStickyState();
      },
      { passive: true }
    );

    window.addEventListener(
      'resize',
      function() {
        if (window.innerWidth >= 1024 && activePanelName === 'menu') {
          closePanels();
        }

        queueWrapperHeightSync();
      },
      { passive: true }
    );

    if (headerResizeMq.addEventListener) {
      headerResizeMq.addEventListener('change', queueWrapperHeightSync);
    } else if (headerResizeMq.addListener) {
      headerResizeMq.addListener(queueWrapperHeightSync);
    }

    if (headerWrapper && typeof MutationObserver === 'function') {
      wrapperObserver = new MutationObserver(function(mutations) {
        var shouldSync = false;

        mutations.forEach(function(mutation) {
          if (mutation.type === 'attributes' && !isSyncingWrapperHeight) {
            shouldSync = true;
          }
        });

        if (shouldSync) {
          queueWrapperHeightSync();
        }
      });

      wrapperObserver.observe(headerWrapper, {
        attributes: true,
        attributeFilter: ['style', 'class']
      });
    }

    updateStickyState();
    updateButtons();
    queueWrapperHeightSync();
  }

  function initAllSupportHeaders(root) {
    var scope = root && root.querySelectorAll ? root : document;

    if (scope.matches && scope.matches('[data-support-header]')) {
      initSupportHeader(scope);
    }

    var sections = scope.querySelectorAll('[data-support-header]');

    sections.forEach(function(section) {
      initSupportHeader(section);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      initAllSupportHeaders(document);
    });
  } else {
    initAllSupportHeaders(document);
  }

  document.addEventListener('shopify:section:load', function(event) {
    initAllSupportHeaders(event.target);
  });
})();
